class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.errorMessage = false;
    if(document.getElementById(`errormessage-${line}`) != null)
      document.getElementById(`errormessage-${line}`).classList.add('hidden');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: (window.location.pathname == "/apps/iwish")?"/collections/all":window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then(async (response) => {
          if (!response.ok) {
             const errorData = await response.json();
             this.errorMessage = errorData;
           
          }
          const state = await response.text();
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
  
          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
        this.disableLoading();
          
      }).catch((state) => {
        console.log(this.errorMessage);
        if(this.errorMessage && typeof this.errorMessage.errors != "undefined") {
          document.getElementById(`errormessage-${line}`).classList.remove('hidden');
          document.querySelector(`#errormessage-${line} .product-form__error-message`).innerHTML = this.errorMessage.errors;
        }
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    $.getJSON('/cart.js', function(cart) {  
     $('.ig-cart-item-count').empty().append('('+cart.item_count+' items)');
     
    //START IG-Nov-100 GST on cart page
    var cartsubtotal = cart.items_subtotal_price;
    if(cartsubtotal){
      var cartGst = $('#basket-right').attr('data-taxrate');
      //var cartGst = {{ settings.cart_gst_rate | plus: 100 }};
      var cartSubtotalWithoutGST = (cartsubtotal*100)/cartGst;
      var gstAmount = cartsubtotal-cartSubtotalWithoutGST;
      $('#basket-right .gst-value').html('$'+Math.round(gstAmount)/100);
    }
    //END IG-Nov-100 GST on cart page 

    if(localStorage.getItem("terms_and_conditions") == 'true'){
      $('#agree').prop('checked', true);
      $('span#terms_text_cart').html("I've read and agree to the");
      $('#shopping-cart #dynamic-checkout-cart').show();
      $('span#terms_text').html("I've read and agree to the");
      $('#checkout').show();
      $('#checkout_placeholder').hide();
      $('#cart_checkout_placeholder').hide();
      $('#cart_checkout').show();
    }else{
      $('#agree').prop('checked', false);
      $('#shopping-cart #dynamic-checkout-cart').hide();
      $('span#terms_text_cart').html("I agree to");
      $('span#terms_text').html("I agree to");
      $('#checkout').hide();
      $('#checkout_placeholder').show();
      $('#cart_checkout_placeholder').show();
      $('#cart_checkout').hide();
    }   
    $('.show-mob.details').hide();
     $('.show-mob.less-details').hide();  
    var product_tags = 0;
    function getProductTag(handle){
      var re = '';
      $.ajax({
            type: 'GET',
            url: '/products/'+handle+'.js',
            cache: false,
            dataType: 'json',
            async: false,
            success: function(product) {
              var tags_all = product.tags;
              if(tags_all.includes("Screen Protectors")){
                  re = 'yes';
                }else{
                  re = 'no';
                }
            }
        });
        return re;
  
    } 
    if(cart.item_count == 0){
       localStorage.removeItem("show-protectors");
    }
    $.each(cart.items, function(index,value){
      var istag = 'no';
      istag = getProductTag(value.handle);
      if(istag == 'yes'){
          product_tags = parseInt(product_tags)+parseInt(value.quantity);
      }
    });
      var old_screen_count = parseInt(localStorage.getItem("screen-protectors"));
      localStorage.setItem("screen-protectors",product_tags);

      if(parseInt(localStorage.getItem("screen-protectors")) % 2 == 1){
        $('#shopping-cart .offer_cart_notification').html('Add another protector for 20% off <span class="close-notif">X</span>');
        $('#shopping-cart .offer_cart_notification').show();
      }else{
        $('#shopping-cart .offer_cart_notification').html('');
        $('#shopping-cart .offer_cart_notification').hide();
      }  
   });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes('/cart')) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const noteFromCart = cart.note;
        const noteField = document.querySelector('#MainContent [name="note"]');
  
        if (noteFromCart && noteField && noteField.value.trim() === "") {
          noteField.value = noteFromCart;
        }
      })
      .catch(error => {
        console.error("Error fetching cart.js:", error);
      });
  }
});
